import PeriprocedureelBeleidTARDaptAsaPraCloTic from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-dapt-asa-pra-clo-tic.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARDaptAsaPraCloTic,
  ChartCollapse,
  React
};